import React from 'react';

import { useAppContext } from 'src/components/app-context';
import { usePriceRowContext } from 'src/areas/product/components/price-list/price-row-context';

import {
  FontColor,
  FontEmphasis,
  FontWeight,
} from '@prisjakt/ui/text/variants';
import type { ContainerType } from '@prisjakt/ui/lib';
import { getCompiledPriceData } from './price-data';

import type { PriceDisplay } from 'src/components/price-list/types';
import { PriceDisplayEnum } from 'src/components/price-list/types';
import type {
  CampaignMediaColors,
  Maybe,
  OfferPrices,
  ProductOffer,
  Shipping,
} from 'src/types';
import type { Offer } from 'src/areas/product/components/price-list/price-row/types';

import {
  PriceAndShipping,
  StyledPriceLabel,
  StyledSecondaryPrice,
  Wrapper,
} from './styles';

interface IPriceLabel {
  campaignColors?: Maybe<CampaignMediaColors>;
  container?: ContainerType;
  priceDisplay: PriceDisplay;
  offer: Offer | ProductOffer;
  offerPrice?: OfferPrices | null;
  shipping?: Shipping;
}

export const OfferPriceLabel = (props: IPriceLabel) => {
  const {
    campaignColors,
    container,
    priceDisplay,
    offer,
    offerPrice,
    shipping,
  } = props;

  const { t, market } = useAppContext();
  const { isFeatured = false } = usePriceRowContext();

  if (!offer.price) {
    return null;
  }

  const priceData = getCompiledPriceData(
    offer.price,
    offerPrice,
    priceDisplay,
    isFeatured,
    t,
    market
  );

  const getPriceLabel = () => {
    const shippingCost = shipping?.shippingCost || 0;
    const cost = offer.price?.exclShipping || 0;

    if (priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING) {
      return cost + shippingCost;
    }
    return cost;
  };

  return (
    <Wrapper>
      <PriceAndShipping>
        {priceData.secondaryPrice && (
          <StyledSecondaryPrice
            memberPrice={priceData.isMemberPrice}
            value={priceData.secondaryPrice}
            emphasis={
              priceData.isMemberPrice ? FontEmphasis.MEDIUM : FontEmphasis.LOW
            }
            weight={FontWeight.NORMAL}
            isSecondaryPrice
          />
        )}

        {getPriceLabel() && (
          <StyledPriceLabel
            container={container}
            emphasis={isFeatured ? FontEmphasis.HIGH : FontEmphasis.LOW}
            fontColor={campaignColors ? FontColor.NEGATIVE : undefined}
            value={getPriceLabel()}
            weight={FontWeight.HEAVIEST}
          />
        )}
      </PriceAndShipping>
    </Wrapper>
  );
};
